import { createContext } from 'react'

export const CustomerDataContext = createContext()
